"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreIdentityAddressStepToJSON = exports.PreIdentityAddressStepFromJSONTyped = exports.PreIdentityAddressStepFromJSON = void 0;
function PreIdentityAddressStepFromJSON(json) {
    return PreIdentityAddressStepFromJSONTyped(json, false);
}
exports.PreIdentityAddressStepFromJSON = PreIdentityAddressStepFromJSON;
function PreIdentityAddressStepFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'everUsedPreviousName': json['everUsedPreviousName'],
        'everUsedAlias': json['everUsedAlias'],
        'useDifferentResidentialAddress': json['useDifferentResidentialAddress'],
        'atCurrentAddressMoreThanFiveYears': json['atCurrentAddressMoreThanFiveYears'],
    };
}
exports.PreIdentityAddressStepFromJSONTyped = PreIdentityAddressStepFromJSONTyped;
function PreIdentityAddressStepToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'everUsedPreviousName': value.everUsedPreviousName,
        'everUsedAlias': value.everUsedAlias,
        'useDifferentResidentialAddress': value.useDifferentResidentialAddress,
        'atCurrentAddressMoreThanFiveYears': value.atCurrentAddressMoreThanFiveYears,
    };
}
exports.PreIdentityAddressStepToJSON = PreIdentityAddressStepToJSON;
//# sourceMappingURL=PreIdentityAddressStep.js.map